import React from 'react';
import { ChevronRight, ChevronDown } from 'tabler-icons-react';
import CeldaCapRow from './CeldaCapRow';

// Compara dos juegos de valores sobre las claves de campo activas.
function rowDirty(current, original, fields) {
    if (!original) return false;
    return fields.some((f) => {
        const a = Number(current[f.key]);
        const b = Number(original[f.key]);
        if (Number.isNaN(a) && Number.isNaN(b)) return false;
        return a !== b;
    });
}

// Sección expandible de una línea: header con resumen + cobertura, y al expandir
// la fila "fuente de verdad" + una fila por celda.
export default function LineaAccordion({
    linea,
    capLinea,
    lineaSaving = false,
    // Si es false, la fila "Capacidad de la línea" es solo lectura (solo se editan las
    // celdas). Products lo deja en true; Capacidades Default lo pasa en false.
    lineaEditable = true,
    celdasCap = [],
    loading = false,
    expanded = false,
    canEdit = false,
    toggle = null,
    // Si se pasa y la capacidad de línea aún no existe, el acordeón entra en "modo
    // carga inicial": se capturan todas las celdas y un único botón hace el POST.
    onCrearCapacidad = null,
    onToggle,
    onChangeLineaField,
    onGuardarLinea,
    onChangeCeldaField,
    onGuardarCelda,
    onResetCelda,
}) {
    const fieldsLinea = capLinea?.fields || [];
    const configuradas = celdasCap.filter((c) => c.configurada).length;
    const total = celdasCap.length;
    const coverState = total === 0 ? 'empty' : configuradas === total ? 'full' : 'partial';
    const modoCarga = !!onCrearCapacidad && !!capLinea && !capLinea.existe;

    return (
        <div className={`cap-linea-acc${toggle && !toggle.on ? ' cap-linea-acc--off' : ''}`}>
            <div className="cap-linea-head">
                <button type="button" className="cap-linea-head-main" onClick={onToggle} aria-expanded={expanded}>
                    {expanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                    <span className="cap-linea-head-name">{linea.nombre}</span>
                    <span className={`cap-linea-coverage cap-linea-coverage--${coverState}`}>
                        <span className="cap-linea-coverage-bar">
                            {Array.from({ length: total }).map((_, i) => (
                                <span
                                    key={i}
                                    className={`cap-linea-coverage-seg${i < configuradas ? ' cap-linea-coverage-seg--on' : ''}`}
                                />
                            ))}
                        </span>
                        <span className="cap-linea-coverage-count">{configuradas}/{total}</span>
                    </span>
                </button>
                {toggle && (
                    <div className="cap-linea-switch">
                        <span className={`cap-linea-switch-label cap-linea-switch-label--${toggle.on ? 'on' : 'off'}`}>
                            {toggle.on ? 'Produce aquí' : 'No produce'}
                        </span>
                        <button
                            type="button"
                            role="switch"
                            aria-checked={toggle.on}
                            aria-label={`${toggle.on ? 'Inhabilitar' : 'Habilitar'} ${linea.nombre} para el producto`}
                            className={`prod-elig-toggle${toggle.on ? ' prod-elig-toggle--on' : ''}`}
                            disabled={toggle.disabled}
                            onClick={toggle.onToggle}
                        >
                            <span className="prod-elig-knob" />
                        </button>
                    </div>
                )}
            </div>

            {expanded && (
                <div className="cap-linea-body">
                    {loading ? (
                        <div className="cap-empty">Cargando celdas…</div>
                    ) : (
                        <>
                            <div className="cap-celda-row cap-celda-row--head">
                                <div className="cap-celda-name">Celda</div>
                                {fieldsLinea.map((f) => (
                                    <div key={f.key} className="cap-celda-cell cap-celda-cell--head">{f.label}</div>
                                ))}
                                <div className="cap-celda-actions" />
                            </div>

                            {capLinea && (
                                <CeldaCapRow
                                    esLinea
                                    fields={fieldsLinea}
                                    valores={capLinea.valores}
                                    configurada={capLinea.existe}
                                    dirty={rowDirty(capLinea.valores, capLinea.original, fieldsLinea)}
                                    saving={lineaSaving}
                                    // Solo editable si la vista lo permite y la capacidad ya existe.
                                    canEdit={lineaEditable && canEdit && capLinea.existe}
                                    onChangeField={(key, val) => onChangeLineaField(key, val)}
                                    onGuardar={onGuardarLinea}
                                />
                            )}

                            {total === 0 ? (
                                <div className="cap-empty">Esta línea no tiene celdas activas</div>
                            ) : (
                                celdasCap.map((celda) => (
                                    <CeldaCapRow
                                        key={celda.celdaId}
                                        nombre={celda.nombre}
                                        esFuente={celda.esFuente}
                                        fields={fieldsLinea}
                                        valores={celda.valores}
                                        defaults={capLinea?.valores}
                                        configurada={celda.configurada}
                                        dirty={rowDirty(celda.valores, celda.original, fieldsLinea)}
                                        saving={celda.saving}
                                        canEdit={canEdit}
                                        sinAcciones={modoCarga}
                                        onChangeField={(key, val) => onChangeCeldaField(celda.celdaId, key, val)}
                                        onGuardar={() => onGuardarCelda(celda.celdaId)}
                                        onReset={() => onResetCelda(celda.celdaId)}
                                    />
                                ))
                            )}

                            {modoCarga && total > 0 && (
                                <div className="cap-crear-linea">
                                    <span className="cap-crear-hint">
                                        Captura la capacidad de todas las celdas y crea la línea para este producto.
                                    </span>
                                    {canEdit && (
                                        <button
                                            type="button"
                                            className="cap-crear-btn"
                                            onClick={onCrearCapacidad}
                                            disabled={lineaSaving}
                                        >
                                            {lineaSaving ? 'Creando…' : 'Crear capacidad de la línea'}
                                        </button>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
